var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.476998,
    y: 1.0185,
    width: 36.8548,
    height: 36.8866,
    rx: 4.5274,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.476998,
    y: 1.0185,
    width: 36.8548,
    height: 36.8866,
    rx: 4.5274,
    stroke: "#DEDFEC",
    strokeWidth: 0.945207
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4931 12.8388C10.6741 12.6578 10.9241 12.5459 11.2002 12.5459H27.2002C27.4763 12.5459 27.7263 12.6578 27.9073 12.8388M10.4931 12.8388C10.3121 13.0198 10.2002 13.2698 10.2002 13.5459V25.5459C10.2002 26.0982 10.6479 26.5459 11.2002 26.5459H27.2002C27.7525 26.5459 28.2002 26.0982 28.2002 25.5459V13.5459C28.2002 13.2698 28.0883 13.0198 27.9073 12.8388M10.4931 12.8388L17.786 20.1316C18.567 20.9127 19.8334 20.9127 20.6144 20.1316L27.9073 12.8388",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.608c40e0cfa768967956a6cd3c2a0ab2.svg";
export { ForwardRef as ReactComponent };